@if (open()) {
  <div class="ef-overlay" (click)="onClose()">
    <div
      class="ef-dialog"
      role="dialog"
      aria-label="Export feedback"
      (click)="$event.stopPropagation()"
    >
      <!-- header -->
      <header class="ef-head">
        <div class="ef-head-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </div>
        <div class="ef-head-text">
          <div class="ef-title">Export feedback</div>
          <div class="ef-subtitle">
            {{ visibleCount() }} of {{ totalCount() }}
            {{ totalCount() === 1 ? 'item' : 'items' }} will be exported ·
            {{ filterChips().length ? 'current filters applied' : 'no filters applied' }}
          </div>
        </div>
        <button class="ef-close" type="button" (click)="onClose()" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </header>

      <!-- active filters -->
      @if (filterChips().length) {
        <div class="ef-filters">
          <span class="ef-filters-label">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
              stroke-linecap="round" stroke-linejoin="round">
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
            </svg>
            Filters
          </span>
          @for (chip of filterChips(); track chip.key) {
            <span class="ef-chip">
              <span class="ef-chip-key">{{ chip.key }}:</span>
              <span class="ef-chip-val">{{ chip.value }}</span>
            </span>
          }
        </div>
      }

      <!-- format options -->
      <div class="ef-body">
        <div class="ef-section-label">Choose a format</div>
        <div class="ef-grid">
          @for (option of options; track option.id) {
            <button
              type="button"
              class="ef-option"
              [disabled]="visibleCount() <= 0"
              (click)="onSelect(option.id)"
            >
              <span class="ef-glyph" [style.background]="option.background" [style.color]="option.foreground">
                @switch (option.glyph) {
                  @case ('sheet') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2" />
                      <line x1="3" y1="9" x2="21" y2="9" /><line x1="3" y1="15" x2="21" y2="15" />
                      <line x1="9" y1="3" x2="9" y2="21" /><line x1="15" y1="3" x2="15" y2="21" />
                    </svg>
                  }
                  @case ('doc') {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="16" y2="17" />
                    </svg>
                  }
                  @default {
                    <span class="ef-glyph-text">{{ glyphText(option.glyph) }}</span>
                  }
                }
              </span>
              <span class="ef-option-text">
                <span class="ef-option-label">{{ option.label }}</span>
                <span class="ef-option-desc">{{ option.description }}</span>
              </span>
            </button>
          }
        </div>
        <p class="ef-note">
          Includes columns: Category, Element, URL, Score, Screen, Status, Type, Created,
          Observation, Recommendation. Sort order from the table is preserved.
        </p>
      </div>
    </div>
  </div>
}
